






import { Component, Vue } from 'vue-property-decorator'
import Admin from '@/views/Admin.vue'
import { UserInterface } from '@/model/user/UserInterface'
import { namespace } from 'vuex-class'

const appModule = namespace('app')

@Component({ components: { Admin } })
export default class AdminApp extends Vue {
  @appModule.State currentUser!: UserInterface
  @appModule.Action getCurrentUser!: () => void

  loaded: boolean = false

  get componentName() {
    return this.isUserAuthenticated ? 'admin' : 'router-view'
  }

  get isUserAuthenticated() {
    return !!this.currentUser
  }

  async beforeMount() {
    await this.getCurrentUser()

    if (!this.isUserAuthenticated && !this.$route.path.includes('login') && !this.$route.path.includes('login')) {
      await this.$router.push('/login')
    }

    this.loaded = true
  }
}
